import { render, staticRenderFns } from "./MetricsCountAppointments.vue?vue&type=template&id=8558b5b4"
import script from "./MetricsCountAppointments.vue?vue&type=script&lang=js"
export * from "./MetricsCountAppointments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports